import Sizes from './sizes';

export default Sizes;